import { render, staticRenderFns } from "./pos-payment-methods.vue?vue&type=template&id=187cd2ed&scoped=true&"
import script from "./pos-payment-methods.vue?vue&type=script&lang=ts&"
export * from "./pos-payment-methods.vue?vue&type=script&lang=ts&"
import style0 from "./pos-payment-methods.vue?vue&type=style&index=0&id=187cd2ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187cd2ed",
  null
  
)

export default component.exports